export default __webpack_public_path__ + "static/team5-c1f9c594ac89c750b8941371f15bbe30.jpg";